import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '../../../visual-feature.js';
import {ClassicCards} from '../classic-cards.js';

import {propCardsFactory} from './prop-cards.factory.js';

import SCHEMA from './prop-cards.schema.yaml';
import PALETTE_SCHEMA from './prop-cards.palette-schema.yaml';

class PropCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'PropCards';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(propCardsFactory(PALETTE), {
            PropCard: {
                marketNameDisplay: this.config.marketNameDisplay,
                contentBackgroundTarget: this.config.contentBackgroundTarget,
                showEventName: this.config.showEventName,
                participantsInline: {
                    showParticipantNames: this.config.showParticipantNames,
                    participantIcons: {
                        showParticipantIcons: this.config.showParticipantIcons,
                    },
                },
            },
        });
    }
}

new PropCardsFeature(ClassicCards);
